import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    BarElement,
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import { Stack } from "@mui/material";
import HotelSwitch from "../components/HotelSwitch";
import Graph from "../util/graph";
import HotelGroupSwitchContent from "../components/HotelGroupSwitchContent";
import moment from "moment";
import { useEffect, useState } from "react";
import HotelChooser from "../components/HotelChooser";
import managerAnalyticsDataFinder from "./managerAnalyticsDataFinder";
import HotelIdValueChooser from "../components/HoteManagerValueChooser";
import labelFinder from "../util/labelFinder";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const ManagerUserAnalyticsGraph = ({
    managerUserAnalytics,
    title,
    isTablularData,
    onToggleTabularData,
    isBar,
    isHotel,
    onToggleHotel,
    isDate,
    isPercentage,
    onToggleBar,
    onToggleDate,
    onTogglePercentage,
}) => {

    const hotels = Object.keys(managerUserAnalytics);
    const [sHotels, setSHotels] = useState([]);
    let [allDates, setAllDates] = useState([])
    const [allOptions, setAllOptions] = useState([])
    const [options, setOptions] = useState([]);

    useEffect(() => {
        setAllDates([...(new Set(Object.values(managerUserAnalytics).map(it => Object.keys(it)).flat()))])
        setSHotels(Object.keys(managerUserAnalytics))
    }, [managerUserAnalytics])

    useEffect(() => {
        let allOptions = {}
        for (let i = 0; i < sHotels.length; i++) {
            let values = Object.values(managerUserAnalytics[sHotels[i]])
            for (let v = 0; v < values.length; v++) {
                let value = values[v]
                let allManagers = Object.keys(value)
                for (let j = 0; j < allManagers.length; j++) {
                    if (!allOptions[allManagers[j]] && value[allManagers[j]].length > 0) {
                        let managerValue = value[allManagers[j]][0]
                        allOptions[allManagers[j]] = {
                            email: managerValue.managerEmail,
                            name: managerValue.managerName,
                            phone: managerValue.managerPhoneNumber,
                            id: allManagers[j]
                        }
                    }
                }
            }
        }
        setAllOptions(Object.values(allOptions))
        setOptions(Object.values(allOptions))
    }, [sHotels])

    const [data, setData] = useState({});

    useEffect(() => {

        let datasets = managerAnalyticsDataFinder(
            managerUserAnalytics,
            allDates,
            isDate,
            options,
            isBar,
            isTablularData,
            sHotels,
            isHotel
        );
        let labels = labelFinder(
            allDates.map((dt) => moment(dt, "DD-MM-YYYY").format("DD-MMM")),
            isHotel,
            isDate,
            sHotels
        );
        // datasets = saleGraphProcessor(isPercentage, datasets, labels.length);
        setData({ labels, datasets });
    }, [
        managerUserAnalytics,
        isDate,
        options,
        isBar,
        isTablularData,
        isPercentage,
        sHotels,
        isHotel,
        allDates
    ]);

    return (
        <div style={{ margin: "20px", paddingTop: "30px", position: "relative" }}>
            <Stack
                style={{
                    position: "absolute",
                    top: "-10px",
                    right: "10px",
                }}
                direction="row"
                spacing={1}
            >
                <HotelGroupSwitchContent
                    content={
                        <>
                            <HotelSwitch
                                isChecked={!isTablularData}
                                label={"Data"}
                                onChange={(v) => {
                                    onToggleTabularData();
                                }}
                            />

                            <HotelSwitch
                                isChecked={isBar}
                                label={"Bar"}
                                onChange={(v) => {
                                    onToggleBar();
                                }}
                            />

                            {hotels.length > 1 ? (
                                <HotelSwitch
                                    isChecked={isHotel}
                                    label={"Hotel"}
                                    onChange={(v) => {
                                        onToggleHotel();
                                    }}
                                />
                            ) : (
                                <></>
                            )}

                            {allDates.length > 1 ? (
                                <HotelSwitch
                                    isChecked={isDate}
                                    label={"Date"}
                                    onChange={(v) => {
                                        onToggleDate();
                                    }}
                                />
                            ) : (
                                <></>
                            )}

                            <HotelSwitch
                                isChecked={isPercentage}
                                label={"Per(%)"}
                                onChange={(v) => {
                                    onTogglePercentage();
                                }}
                            />
                        </>
                    }
                />

                <HotelIdValueChooser
                    managers={allOptions}
                    selectedManagers={options}
                    onManagersChange={(o) => {
                        setOptions(o);
                    }}
                    width="80px"
                />


                <HotelChooser
                    hotels={hotels}
                    selectedHotels={sHotels}
                    onHotelsChange={(s) => {
                        setSHotels(s);
                    }}
                    width="200px"
                />

            </Stack>

            {data &&
                data.datasets &&
                data.datasets.length > 0 &&
                (isBar ? (
                    <Bar
                        style={{ marginTop: "20px" }}
                        options={Graph.BarOptions(
                            title,
                            true,
                            data.datasets.reduce((acc, cur) => {
                                if (!acc[cur.stack]) {
                                    let nAcc = { ...acc };
                                    nAcc[cur.stack] = [cur];
                                    return nAcc;
                                } else {
                                    let nAcc = { ...acc };
                                    nAcc[cur.stack] = [...nAcc[cur.stack], cur];
                                    return nAcc;
                                }
                            }, {})
                        )}
                        data={data}
                    />
                ) : (
                    <Line
                        style={{ marginTop: "20px" }}
                        options={Graph.Options(title)}
                        data={data}
                    />
                ))}
        </div>
    );
};

export default ManagerUserAnalyticsGraph;
